(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-award"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('meowlys-content')) {
  customElements.define('meowlys-content', class extends HTMLElement {
    connectedCallback() {
      this._controller = new AbortController();
      const signal = this._controller.signal;
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-mw-product]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        let target;
        try { target = document.querySelector(this.dataset.productSelector || 'form[action*="/cart/add"]'); } catch (_) { return; }
        if (!target) return;
        event.preventDefault();
        const region = target.closest('product-info') || target.closest('[data-product-section]') || target;
        const parsedOffset = Number(this.dataset.scrollOffset);
        const offset = Number.isFinite(parsedOffset) ? parsedOffset : 100;
        window.scrollTo({top: Math.max(0, region.getBoundingClientRect().top + window.scrollY - offset), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        const focusTarget = target.querySelector('select, input:not([type="hidden"]):not([disabled]), button:not([disabled])');
        if (focusTarget) focusTarget.focus({preventScroll: true});
      }, {signal});
      this._frame = 0;
      this._visible = true;
      this._schedule = () => { if (!this._frame) this._frame = requestAnimationFrame(() => this._update()); };
      const initialize = () => {
        this._timeline = this.querySelector('.zig');
        if (this._timeline) {
        document.addEventListener('scroll', () => { if (this._visible) this._schedule(); }, {passive: true, signal});
        window.addEventListener('resize', this._schedule, {passive: true, signal});
        window.addEventListener('pageshow', this._schedule, {signal});
        if ('IntersectionObserver' in window) {
          this._intersection = new IntersectionObserver(entries => {this._visible=entries[0].isIntersecting;this._schedule();});
          this._intersection.observe(this._timeline);
        }
        if ('ResizeObserver' in window) {
          this._resize = new ResizeObserver(this._schedule);
          this._resize.observe(document.body);
        }
        this._schedule();
        }
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize, {once: true, signal});
      } else { initialize(); }
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const details = event.target.closest('details');
        if (details) details.open=true;
        if (this._timeline) this._schedule();
      }, {signal});
    }
    _update() {
      this._frame=0;
      if (!this.isConnected || !this._timeline) return;
      const line=this._timeline.querySelector('.zline');
      if (!line) return;
      const bounds=line.getBoundingClientRect();
      const readingPoint=window.innerHeight*(Number(this.dataset.readingPoint)||60)/100;
      const progress=Math.max(0,Math.min(1,(readingPoint-bounds.top)/Math.max(1,bounds.height)));
      this._timeline.style.setProperty('--timeline-progress',String(progress));
      this._timeline.querySelectorAll('.zrow').forEach(row => {
        const marker=row.querySelector('.zpill');
        if (!marker) return;
        const rect=marker.getBoundingClientRect();
        row.classList.toggle('is-reached',rect.top+rect.height/2<=readingPoint);
      });
      this._timeline.classList.toggle('is-complete',progress>=1);
    }
    disconnectedCallback() {
      this._controller?.abort();
      this._intersection?.disconnect();
      this._resize?.disconnect();
      cancelAnimationFrame(this._frame);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-comparison-table"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('meowlys-content')) {
  customElements.define('meowlys-content', class extends HTMLElement {
    connectedCallback() {
      this._controller = new AbortController();
      const signal = this._controller.signal;
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-mw-product]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        let target;
        try { target = document.querySelector(this.dataset.productSelector || 'form[action*="/cart/add"]'); } catch (_) { return; }
        if (!target) return;
        event.preventDefault();
        const region = target.closest('product-info') || target.closest('[data-product-section]') || target;
        const parsedOffset = Number(this.dataset.scrollOffset);
        const offset = Number.isFinite(parsedOffset) ? parsedOffset : 100;
        window.scrollTo({top: Math.max(0, region.getBoundingClientRect().top + window.scrollY - offset), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        const focusTarget = target.querySelector('select, input:not([type="hidden"]):not([disabled]), button:not([disabled])');
        if (focusTarget) focusTarget.focus({preventScroll: true});
      }, {signal});
      this._frame = 0;
      this._visible = true;
      this._schedule = () => { if (!this._frame) this._frame = requestAnimationFrame(() => this._update()); };
      const initialize = () => {
        this._timeline = this.querySelector('.zig');
        if (this._timeline) {
        document.addEventListener('scroll', () => { if (this._visible) this._schedule(); }, {passive: true, signal});
        window.addEventListener('resize', this._schedule, {passive: true, signal});
        window.addEventListener('pageshow', this._schedule, {signal});
        if ('IntersectionObserver' in window) {
          this._intersection = new IntersectionObserver(entries => {this._visible=entries[0].isIntersecting;this._schedule();});
          this._intersection.observe(this._timeline);
        }
        if ('ResizeObserver' in window) {
          this._resize = new ResizeObserver(this._schedule);
          this._resize.observe(document.body);
        }
        this._schedule();
        }
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize, {once: true, signal});
      } else { initialize(); }
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const details = event.target.closest('details');
        if (details) details.open=true;
        if (this._timeline) this._schedule();
      }, {signal});
    }
    _update() {
      this._frame=0;
      if (!this.isConnected || !this._timeline) return;
      const line=this._timeline.querySelector('.zline');
      if (!line) return;
      const bounds=line.getBoundingClientRect();
      const readingPoint=window.innerHeight*(Number(this.dataset.readingPoint)||60)/100;
      const progress=Math.max(0,Math.min(1,(readingPoint-bounds.top)/Math.max(1,bounds.height)));
      this._timeline.style.setProperty('--timeline-progress',String(progress));
      this._timeline.querySelectorAll('.zrow').forEach(row => {
        const marker=row.querySelector('.zpill');
        if (!marker) return;
        const rect=marker.getBoundingClientRect();
        row.classList.toggle('is-reached',rect.top+rect.height/2<=readingPoint);
      });
      this._timeline.classList.toggle('is-complete',progress>=1);
    }
    disconnectedCallback() {
      this._controller?.abort();
      this._intersection?.disconnect();
      this._resize?.disconnect();
      cancelAnimationFrame(this._frame);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-cost-comparison"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('meowlys-content')) {
  customElements.define('meowlys-content', class extends HTMLElement {
    connectedCallback() {
      this._controller = new AbortController();
      const signal = this._controller.signal;
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-mw-product]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        let target;
        try { target = document.querySelector(this.dataset.productSelector || 'form[action*="/cart/add"]'); } catch (_) { return; }
        if (!target) return;
        event.preventDefault();
        const region = target.closest('product-info') || target.closest('[data-product-section]') || target;
        const parsedOffset = Number(this.dataset.scrollOffset);
        const offset = Number.isFinite(parsedOffset) ? parsedOffset : 100;
        window.scrollTo({top: Math.max(0, region.getBoundingClientRect().top + window.scrollY - offset), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        const focusTarget = target.querySelector('select, input:not([type="hidden"]):not([disabled]), button:not([disabled])');
        if (focusTarget) focusTarget.focus({preventScroll: true});
      }, {signal});
      this._frame = 0;
      this._visible = true;
      this._schedule = () => { if (!this._frame) this._frame = requestAnimationFrame(() => this._update()); };
      const initialize = () => {
        this._timeline = this.querySelector('.zig');
        if (this._timeline) {
        document.addEventListener('scroll', () => { if (this._visible) this._schedule(); }, {passive: true, signal});
        window.addEventListener('resize', this._schedule, {passive: true, signal});
        window.addEventListener('pageshow', this._schedule, {signal});
        if ('IntersectionObserver' in window) {
          this._intersection = new IntersectionObserver(entries => {this._visible=entries[0].isIntersecting;this._schedule();});
          this._intersection.observe(this._timeline);
        }
        if ('ResizeObserver' in window) {
          this._resize = new ResizeObserver(this._schedule);
          this._resize.observe(document.body);
        }
        this._schedule();
        }
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize, {once: true, signal});
      } else { initialize(); }
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const details = event.target.closest('details');
        if (details) details.open=true;
        if (this._timeline) this._schedule();
      }, {signal});
    }
    _update() {
      this._frame=0;
      if (!this.isConnected || !this._timeline) return;
      const line=this._timeline.querySelector('.zline');
      if (!line) return;
      const bounds=line.getBoundingClientRect();
      const readingPoint=window.innerHeight*(Number(this.dataset.readingPoint)||60)/100;
      const progress=Math.max(0,Math.min(1,(readingPoint-bounds.top)/Math.max(1,bounds.height)));
      this._timeline.style.setProperty('--timeline-progress',String(progress));
      this._timeline.querySelectorAll('.zrow').forEach(row => {
        const marker=row.querySelector('.zpill');
        if (!marker) return;
        const rect=marker.getBoundingClientRect();
        row.classList.toggle('is-reached',rect.top+rect.height/2<=readingPoint);
      });
      this._timeline.classList.toggle('is-complete',progress>=1);
    }
    disconnectedCallback() {
      this._controller?.abort();
      this._intersection?.disconnect();
      this._resize?.disconnect();
      cancelAnimationFrame(this._frame);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-customer-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('meowlys-content')) {
  customElements.define('meowlys-content', class extends HTMLElement {
    connectedCallback() {
      this._controller = new AbortController();
      const signal = this._controller.signal;
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-mw-product]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        let target;
        try { target = document.querySelector(this.dataset.productSelector || 'form[action*="/cart/add"]'); } catch (_) { return; }
        if (!target) return;
        event.preventDefault();
        const region = target.closest('product-info') || target.closest('[data-product-section]') || target;
        const parsedOffset = Number(this.dataset.scrollOffset);
        const offset = Number.isFinite(parsedOffset) ? parsedOffset : 100;
        window.scrollTo({top: Math.max(0, region.getBoundingClientRect().top + window.scrollY - offset), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        const focusTarget = target.querySelector('select, input:not([type="hidden"]):not([disabled]), button:not([disabled])');
        if (focusTarget) focusTarget.focus({preventScroll: true});
      }, {signal});
      this._frame = 0;
      this._visible = true;
      this._schedule = () => { if (!this._frame) this._frame = requestAnimationFrame(() => this._update()); };
      const initialize = () => {
        this._timeline = this.querySelector('.zig');
        if (this._timeline) {
        document.addEventListener('scroll', () => { if (this._visible) this._schedule(); }, {passive: true, signal});
        window.addEventListener('resize', this._schedule, {passive: true, signal});
        window.addEventListener('pageshow', this._schedule, {signal});
        if ('IntersectionObserver' in window) {
          this._intersection = new IntersectionObserver(entries => {this._visible=entries[0].isIntersecting;this._schedule();});
          this._intersection.observe(this._timeline);
        }
        if ('ResizeObserver' in window) {
          this._resize = new ResizeObserver(this._schedule);
          this._resize.observe(document.body);
        }
        this._schedule();
        }
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize, {once: true, signal});
      } else { initialize(); }
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const details = event.target.closest('details');
        if (details) details.open=true;
        if (this._timeline) this._schedule();
      }, {signal});
    }
    _update() {
      this._frame=0;
      if (!this.isConnected || !this._timeline) return;
      const line=this._timeline.querySelector('.zline');
      if (!line) return;
      const bounds=line.getBoundingClientRect();
      const readingPoint=window.innerHeight*(Number(this.dataset.readingPoint)||60)/100;
      const progress=Math.max(0,Math.min(1,(readingPoint-bounds.top)/Math.max(1,bounds.height)));
      this._timeline.style.setProperty('--timeline-progress',String(progress));
      this._timeline.querySelectorAll('.zrow').forEach(row => {
        const marker=row.querySelector('.zpill');
        if (!marker) return;
        const rect=marker.getBoundingClientRect();
        row.classList.toggle('is-reached',rect.top+rect.height/2<=readingPoint);
      });
      this._timeline.classList.toggle('is-complete',progress>=1);
    }
    disconnectedCallback() {
      this._controller?.abort();
      this._intersection?.disconnect();
      this._resize?.disconnect();
      cancelAnimationFrame(this._frame);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-expert"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('meowlys-content')) {
  customElements.define('meowlys-content', class extends HTMLElement {
    connectedCallback() {
      this._controller = new AbortController();
      const signal = this._controller.signal;
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-mw-product]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        let target;
        try { target = document.querySelector(this.dataset.productSelector || 'form[action*="/cart/add"]'); } catch (_) { return; }
        if (!target) return;
        event.preventDefault();
        const region = target.closest('product-info') || target.closest('[data-product-section]') || target;
        const parsedOffset = Number(this.dataset.scrollOffset);
        const offset = Number.isFinite(parsedOffset) ? parsedOffset : 100;
        window.scrollTo({top: Math.max(0, region.getBoundingClientRect().top + window.scrollY - offset), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        const focusTarget = target.querySelector('select, input:not([type="hidden"]):not([disabled]), button:not([disabled])');
        if (focusTarget) focusTarget.focus({preventScroll: true});
      }, {signal});
      this._frame = 0;
      this._visible = true;
      this._schedule = () => { if (!this._frame) this._frame = requestAnimationFrame(() => this._update()); };
      const initialize = () => {
        this._timeline = this.querySelector('.zig');
        if (this._timeline) {
        document.addEventListener('scroll', () => { if (this._visible) this._schedule(); }, {passive: true, signal});
        window.addEventListener('resize', this._schedule, {passive: true, signal});
        window.addEventListener('pageshow', this._schedule, {signal});
        if ('IntersectionObserver' in window) {
          this._intersection = new IntersectionObserver(entries => {this._visible=entries[0].isIntersecting;this._schedule();});
          this._intersection.observe(this._timeline);
        }
        if ('ResizeObserver' in window) {
          this._resize = new ResizeObserver(this._schedule);
          this._resize.observe(document.body);
        }
        this._schedule();
        }
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize, {once: true, signal});
      } else { initialize(); }
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const details = event.target.closest('details');
        if (details) details.open=true;
        if (this._timeline) this._schedule();
      }, {signal});
    }
    _update() {
      this._frame=0;
      if (!this.isConnected || !this._timeline) return;
      const line=this._timeline.querySelector('.zline');
      if (!line) return;
      const bounds=line.getBoundingClientRect();
      const readingPoint=window.innerHeight*(Number(this.dataset.readingPoint)||60)/100;
      const progress=Math.max(0,Math.min(1,(readingPoint-bounds.top)/Math.max(1,bounds.height)));
      this._timeline.style.setProperty('--timeline-progress',String(progress));
      this._timeline.querySelectorAll('.zrow').forEach(row => {
        const marker=row.querySelector('.zpill');
        if (!marker) return;
        const rect=marker.getBoundingClientRect();
        row.classList.toggle('is-reached',rect.top+rect.height/2<=readingPoint);
      });
      this._timeline.classList.toggle('is-complete',progress>=1);
    }
    disconnectedCallback() {
      this._controller?.abort();
      this._intersection?.disconnect();
      this._resize?.disconnect();
      cancelAnimationFrame(this._frame);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-faq"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('meowlys-content')) {
  customElements.define('meowlys-content', class extends HTMLElement {
    connectedCallback() {
      this._controller = new AbortController();
      const signal = this._controller.signal;
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-mw-product]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        let target;
        try { target = document.querySelector(this.dataset.productSelector || 'form[action*="/cart/add"]'); } catch (_) { return; }
        if (!target) return;
        event.preventDefault();
        const region = target.closest('product-info') || target.closest('[data-product-section]') || target;
        const parsedOffset = Number(this.dataset.scrollOffset);
        const offset = Number.isFinite(parsedOffset) ? parsedOffset : 100;
        window.scrollTo({top: Math.max(0, region.getBoundingClientRect().top + window.scrollY - offset), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        const focusTarget = target.querySelector('select, input:not([type="hidden"]):not([disabled]), button:not([disabled])');
        if (focusTarget) focusTarget.focus({preventScroll: true});
      }, {signal});
      this._frame = 0;
      this._visible = true;
      this._schedule = () => { if (!this._frame) this._frame = requestAnimationFrame(() => this._update()); };
      const initialize = () => {
        this._timeline = this.querySelector('.zig');
        if (this._timeline) {
        document.addEventListener('scroll', () => { if (this._visible) this._schedule(); }, {passive: true, signal});
        window.addEventListener('resize', this._schedule, {passive: true, signal});
        window.addEventListener('pageshow', this._schedule, {signal});
        if ('IntersectionObserver' in window) {
          this._intersection = new IntersectionObserver(entries => {this._visible=entries[0].isIntersecting;this._schedule();});
          this._intersection.observe(this._timeline);
        }
        if ('ResizeObserver' in window) {
          this._resize = new ResizeObserver(this._schedule);
          this._resize.observe(document.body);
        }
        this._schedule();
        }
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize, {once: true, signal});
      } else { initialize(); }
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const details = event.target.closest('details');
        if (details) details.open=true;
        if (this._timeline) this._schedule();
      }, {signal});
    }
    _update() {
      this._frame=0;
      if (!this.isConnected || !this._timeline) return;
      const line=this._timeline.querySelector('.zline');
      if (!line) return;
      const bounds=line.getBoundingClientRect();
      const readingPoint=window.innerHeight*(Number(this.dataset.readingPoint)||60)/100;
      const progress=Math.max(0,Math.min(1,(readingPoint-bounds.top)/Math.max(1,bounds.height)));
      this._timeline.style.setProperty('--timeline-progress',String(progress));
      this._timeline.querySelectorAll('.zrow').forEach(row => {
        const marker=row.querySelector('.zpill');
        if (!marker) return;
        const rect=marker.getBoundingClientRect();
        row.classList.toggle('is-reached',rect.top+rect.height/2<=readingPoint);
      });
      this._timeline.classList.toggle('is-complete',progress>=1);
    }
    disconnectedCallback() {
      this._controller?.abort();
      this._intersection?.disconnect();
      this._resize?.disconnect();
      cancelAnimationFrame(this._frame);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-final-offer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mw-final-offer')) {
  customElements.define('mw-final-offer', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.ready = () => {
        this.bundle = document.querySelector(this.dataset.bundleSelector || 'main quantity-breaks');
        this.button = this.querySelector('.mw-final-submit');
        this.status = this.querySelector('.mw-final-status');
        const first = this.bundle && this.bundle.querySelector('input[name="quantity"]');
        this.form = first && first.form;
        this.submit = this.form && this.form.querySelector('button[type="submit"]');
        if (!first || !this.submit) {
          this.status.textContent = 'Please choose your packs using the product bundle above.';
          return;
        }
        this.sync = () => {
          const main = this.bundle.querySelector('input[name="quantity"]:checked');
          this.querySelectorAll('.mw-final-radio').forEach(radio => { radio.checked = !!main && radio.value === main.value; });
          const selected = this.querySelector('.mw-final-radio:checked');
          this.querySelector('.mw-final-renewal').textContent = selected ? selected.dataset.renewal : '';
          this.button.disabled = !selected || this.submit.disabled || this.submit.getAttribute('aria-disabled') === 'true';
          this.button.setAttribute('aria-busy', this.submit.classList.contains('loading') ? 'true' : 'false');
        };
        this.addEventListener('change', event => {
          if (!event.target.matches('.mw-final-radio')) return;
          const target = Array.from(this.bundle.querySelectorAll('input[name="quantity"]')).find(radio => radio.value === event.target.value);
          if (target) target.click();
          this.status.textContent = '';
          this.sync();
        }, {signal});
        this.bundle.addEventListener('change', () => this.sync(), {signal});
        this.button.addEventListener('click', () => {
          this.sync();
          if (this.button.disabled) return;
          this.submit.click();
          this.sync();
        }, {signal});
        this.observer = new MutationObserver(() => {
          this.sync();
          const error = this.form.closest('product-form')?.querySelector('.product-form__error-message');
          const wrapper = error?.closest('.product-form__error-message-wrapper');
          this.status.textContent = wrapper && !wrapper.hidden ? error.textContent.trim() : '';
        });
        this.observer.observe(this.form, {attributes:true,subtree:true,childList:true,characterData:true});
        this.sync();
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.ready, {once:true,signal});
      else this.ready();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-grass-comparison"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('meowlys-content')) {
  customElements.define('meowlys-content', class extends HTMLElement {
    connectedCallback() {
      this._controller = new AbortController();
      const signal = this._controller.signal;
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-mw-product]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        let target;
        try { target = document.querySelector(this.dataset.productSelector || 'form[action*="/cart/add"]'); } catch (_) { return; }
        if (!target) return;
        event.preventDefault();
        const region = target.closest('product-info') || target.closest('[data-product-section]') || target;
        const parsedOffset = Number(this.dataset.scrollOffset);
        const offset = Number.isFinite(parsedOffset) ? parsedOffset : 100;
        window.scrollTo({top: Math.max(0, region.getBoundingClientRect().top + window.scrollY - offset), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        const focusTarget = target.querySelector('select, input:not([type="hidden"]):not([disabled]), button:not([disabled])');
        if (focusTarget) focusTarget.focus({preventScroll: true});
      }, {signal});
      this._frame = 0;
      this._visible = true;
      this._schedule = () => { if (!this._frame) this._frame = requestAnimationFrame(() => this._update()); };
      const initialize = () => {
        this._timeline = this.querySelector('.zig');
        if (this._timeline) {
        document.addEventListener('scroll', () => { if (this._visible) this._schedule(); }, {passive: true, signal});
        window.addEventListener('resize', this._schedule, {passive: true, signal});
        window.addEventListener('pageshow', this._schedule, {signal});
        if ('IntersectionObserver' in window) {
          this._intersection = new IntersectionObserver(entries => {this._visible=entries[0].isIntersecting;this._schedule();});
          this._intersection.observe(this._timeline);
        }
        if ('ResizeObserver' in window) {
          this._resize = new ResizeObserver(this._schedule);
          this._resize.observe(document.body);
        }
        this._schedule();
        }
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize, {once: true, signal});
      } else { initialize(); }
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const details = event.target.closest('details');
        if (details) details.open=true;
        if (this._timeline) this._schedule();
      }, {signal});
    }
    _update() {
      this._frame=0;
      if (!this.isConnected || !this._timeline) return;
      const line=this._timeline.querySelector('.zline');
      if (!line) return;
      const bounds=line.getBoundingClientRect();
      const readingPoint=window.innerHeight*(Number(this.dataset.readingPoint)||60)/100;
      const progress=Math.max(0,Math.min(1,(readingPoint-bounds.top)/Math.max(1,bounds.height)));
      this._timeline.style.setProperty('--timeline-progress',String(progress));
      this._timeline.querySelectorAll('.zrow').forEach(row => {
        const marker=row.querySelector('.zpill');
        if (!marker) return;
        const rect=marker.getBoundingClientRect();
        row.classList.toggle('is-reached',rect.top+rect.height/2<=readingPoint);
      });
      this._timeline.classList.toggle('is-complete',progress>=1);
    }
    disconnectedCallback() {
      this._controller?.abort();
      this._intersection?.disconnect();
      this._resize?.disconnect();
      cancelAnimationFrame(this._frame);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-grass-science"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('meowlys-content')) {
  customElements.define('meowlys-content', class extends HTMLElement {
    connectedCallback() {
      this._controller = new AbortController();
      const signal = this._controller.signal;
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-mw-product]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        let target;
        try { target = document.querySelector(this.dataset.productSelector || 'form[action*="/cart/add"]'); } catch (_) { return; }
        if (!target) return;
        event.preventDefault();
        const region = target.closest('product-info') || target.closest('[data-product-section]') || target;
        const parsedOffset = Number(this.dataset.scrollOffset);
        const offset = Number.isFinite(parsedOffset) ? parsedOffset : 100;
        window.scrollTo({top: Math.max(0, region.getBoundingClientRect().top + window.scrollY - offset), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        const focusTarget = target.querySelector('select, input:not([type="hidden"]):not([disabled]), button:not([disabled])');
        if (focusTarget) focusTarget.focus({preventScroll: true});
      }, {signal});
      this._frame = 0;
      this._visible = true;
      this._schedule = () => { if (!this._frame) this._frame = requestAnimationFrame(() => this._update()); };
      const initialize = () => {
        this._timeline = this.querySelector('.zig');
        if (this._timeline) {
        document.addEventListener('scroll', () => { if (this._visible) this._schedule(); }, {passive: true, signal});
        window.addEventListener('resize', this._schedule, {passive: true, signal});
        window.addEventListener('pageshow', this._schedule, {signal});
        if ('IntersectionObserver' in window) {
          this._intersection = new IntersectionObserver(entries => {this._visible=entries[0].isIntersecting;this._schedule();});
          this._intersection.observe(this._timeline);
        }
        if ('ResizeObserver' in window) {
          this._resize = new ResizeObserver(this._schedule);
          this._resize.observe(document.body);
        }
        this._schedule();
        }
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize, {once: true, signal});
      } else { initialize(); }
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const details = event.target.closest('details');
        if (details) details.open=true;
        if (this._timeline) this._schedule();
      }, {signal});
    }
    _update() {
      this._frame=0;
      if (!this.isConnected || !this._timeline) return;
      const line=this._timeline.querySelector('.zline');
      if (!line) return;
      const bounds=line.getBoundingClientRect();
      const readingPoint=window.innerHeight*(Number(this.dataset.readingPoint)||60)/100;
      const progress=Math.max(0,Math.min(1,(readingPoint-bounds.top)/Math.max(1,bounds.height)));
      this._timeline.style.setProperty('--timeline-progress',String(progress));
      this._timeline.querySelectorAll('.zrow').forEach(row => {
        const marker=row.querySelector('.zpill');
        if (!marker) return;
        const rect=marker.getBoundingClientRect();
        row.classList.toggle('is-reached',rect.top+rect.height/2<=readingPoint);
      });
      this._timeline.classList.toggle('is-complete',progress>=1);
    }
    disconnectedCallback() {
      this._controller?.abort();
      this._intersection?.disconnect();
      this._resize?.disconnect();
      cancelAnimationFrame(this._frame);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-guarantee"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('meowlys-content')) {
  customElements.define('meowlys-content', class extends HTMLElement {
    connectedCallback() {
      this._controller = new AbortController();
      const signal = this._controller.signal;
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-mw-product]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        let target;
        try { target = document.querySelector(this.dataset.productSelector || 'form[action*="/cart/add"]'); } catch (_) { return; }
        if (!target) return;
        event.preventDefault();
        const region = target.closest('product-info') || target.closest('[data-product-section]') || target;
        const parsedOffset = Number(this.dataset.scrollOffset);
        const offset = Number.isFinite(parsedOffset) ? parsedOffset : 100;
        window.scrollTo({top: Math.max(0, region.getBoundingClientRect().top + window.scrollY - offset), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        const focusTarget = target.querySelector('select, input:not([type="hidden"]):not([disabled]), button:not([disabled])');
        if (focusTarget) focusTarget.focus({preventScroll: true});
      }, {signal});
      this._frame = 0;
      this._visible = true;
      this._schedule = () => { if (!this._frame) this._frame = requestAnimationFrame(() => this._update()); };
      const initialize = () => {
        this._timeline = this.querySelector('.zig');
        if (this._timeline) {
        document.addEventListener('scroll', () => { if (this._visible) this._schedule(); }, {passive: true, signal});
        window.addEventListener('resize', this._schedule, {passive: true, signal});
        window.addEventListener('pageshow', this._schedule, {signal});
        if ('IntersectionObserver' in window) {
          this._intersection = new IntersectionObserver(entries => {this._visible=entries[0].isIntersecting;this._schedule();});
          this._intersection.observe(this._timeline);
        }
        if ('ResizeObserver' in window) {
          this._resize = new ResizeObserver(this._schedule);
          this._resize.observe(document.body);
        }
        this._schedule();
        }
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize, {once: true, signal});
      } else { initialize(); }
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const details = event.target.closest('details');
        if (details) details.open=true;
        if (this._timeline) this._schedule();
      }, {signal});
    }
    _update() {
      this._frame=0;
      if (!this.isConnected || !this._timeline) return;
      const line=this._timeline.querySelector('.zline');
      if (!line) return;
      const bounds=line.getBoundingClientRect();
      const readingPoint=window.innerHeight*(Number(this.dataset.readingPoint)||60)/100;
      const progress=Math.max(0,Math.min(1,(readingPoint-bounds.top)/Math.max(1,bounds.height)));
      this._timeline.style.setProperty('--timeline-progress',String(progress));
      this._timeline.querySelectorAll('.zrow').forEach(row => {
        const marker=row.querySelector('.zpill');
        if (!marker) return;
        const rect=marker.getBoundingClientRect();
        row.classList.toggle('is-reached',rect.top+rect.height/2<=readingPoint);
      });
      this._timeline.classList.toggle('is-complete',progress>=1);
    }
    disconnectedCallback() {
      this._controller?.abort();
      this._intersection?.disconnect();
      this._resize?.disconnect();
      cancelAnimationFrame(this._frame);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-photo-strip"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('meowlys-content')) {
  customElements.define('meowlys-content', class extends HTMLElement {
    connectedCallback() {
      this._controller = new AbortController();
      const signal = this._controller.signal;
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-mw-product]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        let target;
        try { target = document.querySelector(this.dataset.productSelector || 'form[action*="/cart/add"]'); } catch (_) { return; }
        if (!target) return;
        event.preventDefault();
        const region = target.closest('product-info') || target.closest('[data-product-section]') || target;
        const parsedOffset = Number(this.dataset.scrollOffset);
        const offset = Number.isFinite(parsedOffset) ? parsedOffset : 100;
        window.scrollTo({top: Math.max(0, region.getBoundingClientRect().top + window.scrollY - offset), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        const focusTarget = target.querySelector('select, input:not([type="hidden"]):not([disabled]), button:not([disabled])');
        if (focusTarget) focusTarget.focus({preventScroll: true});
      }, {signal});
      this._frame = 0;
      this._visible = true;
      this._schedule = () => { if (!this._frame) this._frame = requestAnimationFrame(() => this._update()); };
      const initialize = () => {
        this._timeline = this.querySelector('.zig');
        if (this._timeline) {
        document.addEventListener('scroll', () => { if (this._visible) this._schedule(); }, {passive: true, signal});
        window.addEventListener('resize', this._schedule, {passive: true, signal});
        window.addEventListener('pageshow', this._schedule, {signal});
        if ('IntersectionObserver' in window) {
          this._intersection = new IntersectionObserver(entries => {this._visible=entries[0].isIntersecting;this._schedule();});
          this._intersection.observe(this._timeline);
        }
        if ('ResizeObserver' in window) {
          this._resize = new ResizeObserver(this._schedule);
          this._resize.observe(document.body);
        }
        this._schedule();
        }
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize, {once: true, signal});
      } else { initialize(); }
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const details = event.target.closest('details');
        if (details) details.open=true;
        if (this._timeline) this._schedule();
      }, {signal});
    }
    _update() {
      this._frame=0;
      if (!this.isConnected || !this._timeline) return;
      const line=this._timeline.querySelector('.zline');
      if (!line) return;
      const bounds=line.getBoundingClientRect();
      const readingPoint=window.innerHeight*(Number(this.dataset.readingPoint)||60)/100;
      const progress=Math.max(0,Math.min(1,(readingPoint-bounds.top)/Math.max(1,bounds.height)));
      this._timeline.style.setProperty('--timeline-progress',String(progress));
      this._timeline.querySelectorAll('.zrow').forEach(row => {
        const marker=row.querySelector('.zpill');
        if (!marker) return;
        const rect=marker.getBoundingClientRect();
        row.classList.toggle('is-reached',rect.top+rect.height/2<=readingPoint);
      });
      this._timeline.classList.toggle('is-complete',progress>=1);
    }
    disconnectedCallback() {
      this._controller?.abort();
      this._intersection?.disconnect();
      this._resize?.disconnect();
      cancelAnimationFrame(this._frame);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-results"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('meowlys-content')) {
  customElements.define('meowlys-content', class extends HTMLElement {
    connectedCallback() {
      this._controller = new AbortController();
      const signal = this._controller.signal;
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-mw-product]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        let target;
        try { target = document.querySelector(this.dataset.productSelector || 'form[action*="/cart/add"]'); } catch (_) { return; }
        if (!target) return;
        event.preventDefault();
        const region = target.closest('product-info') || target.closest('[data-product-section]') || target;
        const parsedOffset = Number(this.dataset.scrollOffset);
        const offset = Number.isFinite(parsedOffset) ? parsedOffset : 100;
        window.scrollTo({top: Math.max(0, region.getBoundingClientRect().top + window.scrollY - offset), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        const focusTarget = target.querySelector('select, input:not([type="hidden"]):not([disabled]), button:not([disabled])');
        if (focusTarget) focusTarget.focus({preventScroll: true});
      }, {signal});
      this._frame = 0;
      this._visible = true;
      this._schedule = () => { if (!this._frame) this._frame = requestAnimationFrame(() => this._update()); };
      const initialize = () => {
        this._timeline = this.querySelector('.zig');
        if (this._timeline) {
        document.addEventListener('scroll', () => { if (this._visible) this._schedule(); }, {passive: true, signal});
        window.addEventListener('resize', this._schedule, {passive: true, signal});
        window.addEventListener('pageshow', this._schedule, {signal});
        if ('IntersectionObserver' in window) {
          this._intersection = new IntersectionObserver(entries => {this._visible=entries[0].isIntersecting;this._schedule();});
          this._intersection.observe(this._timeline);
        }
        if ('ResizeObserver' in window) {
          this._resize = new ResizeObserver(this._schedule);
          this._resize.observe(document.body);
        }
        this._schedule();
        }
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize, {once: true, signal});
      } else { initialize(); }
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const details = event.target.closest('details');
        if (details) details.open=true;
        if (this._timeline) this._schedule();
      }, {signal});
    }
    _update() {
      this._frame=0;
      if (!this.isConnected || !this._timeline) return;
      const line=this._timeline.querySelector('.zline');
      if (!line) return;
      const bounds=line.getBoundingClientRect();
      const readingPoint=window.innerHeight*(Number(this.dataset.readingPoint)||60)/100;
      const progress=Math.max(0,Math.min(1,(readingPoint-bounds.top)/Math.max(1,bounds.height)));
      this._timeline.style.setProperty('--timeline-progress',String(progress));
      this._timeline.querySelectorAll('.zrow').forEach(row => {
        const marker=row.querySelector('.zpill');
        if (!marker) return;
        const rect=marker.getBoundingClientRect();
        row.classList.toggle('is-reached',rect.top+rect.height/2<=readingPoint);
      });
      this._timeline.classList.toggle('is-complete',progress>=1);
    }
    disconnectedCallback() {
      this._controller?.abort();
      this._intersection?.disconnect();
      this._resize?.disconnect();
      cancelAnimationFrame(this._frame);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-timeline"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('meowlys-content')) {
  customElements.define('meowlys-content', class extends HTMLElement {
    connectedCallback() {
      this._controller = new AbortController();
      const signal = this._controller.signal;
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-mw-product]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        let target;
        try { target = document.querySelector(this.dataset.productSelector || 'form[action*="/cart/add"]'); } catch (_) { return; }
        if (!target) return;
        event.preventDefault();
        const region = target.closest('product-info') || target.closest('[data-product-section]') || target;
        const parsedOffset = Number(this.dataset.scrollOffset);
        const offset = Number.isFinite(parsedOffset) ? parsedOffset : 100;
        window.scrollTo({top: Math.max(0, region.getBoundingClientRect().top + window.scrollY - offset), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        const focusTarget = target.querySelector('select, input:not([type="hidden"]):not([disabled]), button:not([disabled])');
        if (focusTarget) focusTarget.focus({preventScroll: true});
      }, {signal});
      this._frame = 0;
      this._visible = true;
      this._schedule = () => { if (!this._frame) this._frame = requestAnimationFrame(() => this._update()); };
      const initialize = () => {
        this._timeline = this.querySelector('.zig');
        if (this._timeline) {
        document.addEventListener('scroll', () => { if (this._visible) this._schedule(); }, {passive: true, signal});
        window.addEventListener('resize', this._schedule, {passive: true, signal});
        window.addEventListener('pageshow', this._schedule, {signal});
        if ('IntersectionObserver' in window) {
          this._intersection = new IntersectionObserver(entries => {this._visible=entries[0].isIntersecting;this._schedule();});
          this._intersection.observe(this._timeline);
        }
        if ('ResizeObserver' in window) {
          this._resize = new ResizeObserver(this._schedule);
          this._resize.observe(document.body);
        }
        this._schedule();
        }
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize, {once: true, signal});
      } else { initialize(); }
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const details = event.target.closest('details');
        if (details) details.open=true;
        if (this._timeline) this._schedule();
      }, {signal});
    }
    _update() {
      this._frame=0;
      if (!this.isConnected || !this._timeline) return;
      const line=this._timeline.querySelector('.zline');
      if (!line) return;
      const bounds=line.getBoundingClientRect();
      const readingPoint=window.innerHeight*(Number(this.dataset.readingPoint)||60)/100;
      const progress=Math.max(0,Math.min(1,(readingPoint-bounds.top)/Math.max(1,bounds.height)));
      this._timeline.style.setProperty('--timeline-progress',String(progress));
      this._timeline.querySelectorAll('.zrow').forEach(row => {
        const marker=row.querySelector('.zpill');
        if (!marker) return;
        const rect=marker.getBoundingClientRect();
        row.classList.toggle('is-reached',rect.top+rect.height/2<=readingPoint);
      });
      this._timeline.classList.toggle('is-complete',progress>=1);
    }
    disconnectedCallback() {
      this._controller?.abort();
      this._intersection?.disconnect();
      this._resize?.disconnect();
      cancelAnimationFrame(this._frame);
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
